module.exports = __webpack_public_path__ + "02_medium_grey.5b6f6a5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/02_medium_grey.png
// module id = c18D
// module chunks = 0